import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import { translations } from '@/i18n';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Chatbot from '@/components/Chatbot';
import GlobeCursor from '@/components/GlobeCursor';
import LandingPage from '@/pages/LandingPage';
import ServicePage from '@/pages/ServicePage';
import BookingPage from '@/pages/BookingPage';
import BlogDetailPage from '@/pages/BlogDetailPage';
import AdminPage from '@/pages/AdminPage';

function App() {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem('cauratech_lang');
      return saved === 'en' ? 'en' : 'es';
    } catch (err) {
      // localStorage may be disabled (private mode / strict cookies); default to Spanish.
      console.warn('[App] localStorage read for lang failed:', err?.message || err);
      return 'es';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('cauratech_lang', lang);
    } catch (err) {
      console.warn('[App] localStorage write for lang failed:', err?.message || err);
    }
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];

  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App dark" data-testid="app-root">
          <GlobeCursor />
          <Navbar lang={lang} setLang={setLang} t={t} />
          <Routes>
            <Route path="/" element={<LandingPage lang={lang} />} />
            <Route path="/servicios/:slug" element={<ServicePage lang={lang} />} />
            <Route path="/agenda" element={<BookingPage lang={lang} />} />
            <Route path="/blog/:slug" element={<BlogDetailPage lang={lang} />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<LandingPage lang={lang} />} />
          </Routes>
          <Footer lang={lang} t={t} />
          <Chatbot lang={lang} t={t} />
          <Toaster position="top-right" theme="dark" />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
